/** スタイルに関連する utils */
import { SkillMastar } from "@/api/dto/Skill";

/**
 * 言語に応じたスタイルクラスを取得
 * @param {string} lang - 言語 
 * @returns - スタイルクラス
 */
export const getColorClass = (lang: string): string => {
  const localSkill: SkillMastar[] = JSON.parse(localStorage.getItem('skill') as string);
  const targetSkill = localSkill.find(({ skillName }) => skillName === lang);
  switch(targetSkill?.languageColor) {
    case '1':
      return "color-type-1";
    case '2':
      return "color-type-2";
    case '3':
      return "color-type-3";
    case '4':
      return "color-type-4";
    case '5':
      return "color-type-5";
    case '6':
      return "color-type-6";
    case '7':
      return "color-type-7";
    case '8':
      return "color-type-8";
    case '9':
      return "color-type-9";
    case '10':
      return "color-type-10";
    default:
      return "default"
  }
}